import request from '@src/services/request';
import { cryptoEncryptBase } from '@src/utils/encryption';

// 获取邮箱验证码
export const getEmailCode = async (email = '') => {
  const res = await request({
    method: 'post',
    url: '/reset_password/send_email',
    data: {
      email
    }
  });

  return !!res;
};

// 修改密码
export const changePassword = async ({
  email,
  password,
  code,
}) => {
  const res = await request({
    method: 'post',
    url: '/reset_password',
    data: {
      email,
      password: cryptoEncryptBase(password),
      verification_code: code,
    }
  });

  return !!res;
};
